import React from 'react'
import { InspectorLayersTreeNode } from 'modules/shares/ArtboardDetailView/hooks/inspector'

import { ReactComponent as ArtboardIcon } from '@sketch/icons/artboard-16'
import { ReactComponent as TextIcon } from '@sketch/icons/text-format-16'
import { ReactComponent as ShapeIcon } from '@sketch/icons/squares-2-16'
import { ReactComponent as GroupIcon } from '@sketch/icons/folder-open-16'
import { ReactComponent as BitmapIcon } from '@sketch/icons/image-16'
import { ReactComponent as SliceIcon } from '@sketch/icons/square-knife-16'
import { ReactComponent as SymbolIcon } from '@sketch/icons/symbol-16'

import { ExportableIcon } from '../../ExportableIcon'
import * as S from './LayerIcon.styles'

export interface IconProps {
  maskColor?: string
  layerType: InspectorLayersTreeNode['type']
  isLayerMasked: boolean
  isLayerExportable: boolean
}
export function LayerIcon({
  layerType,
  maskColor,
  isLayerMasked,
  isLayerExportable,
}: IconProps) {
  return (
    <S.LayerIconContainer>
      {isLayerMasked && <S.StyledMaskedIcon />}
      <ContextMenuLayerIcon layerType={layerType} />
      {/* Slice already has an exportable icon present on the icon */}
      {isLayerExportable && layerType !== 'slice' && (
        <ExportableIcon maskColor={maskColor} />
      )}
    </S.LayerIconContainer>
  )
}

interface ContextMenuLayerIconProps {
  layerType: InspectorLayersTreeNode['type']
}

// Gets the layer icon url based on the layer type.
const ContextMenuLayerIcon = ({ layerType }: ContextMenuLayerIconProps) => {
  switch (layerType) {
    case 'artboard':
      return <ArtboardIcon width={17} height={17} />
    case 'bitmap':
      return <BitmapIcon width={17} height={17} />
    case 'text':
      return <TextIcon width={17} height={17} />
    case 'group':
      return <GroupIcon width={17} height={17} />
    case 'slice':
      return <SliceIcon width={17} height={17} />
    case 'symbolInstance':
      return <SymbolIcon width={17} height={17} />
    default:
      return <ShapeIcon width={17} height={17} />
  }
}
